import { Box, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface Props {
  name: string;
  balancePercent: number;
  color?: string;
}

const PieChartCompanyListItem: FC<Props> = ({
  name,
  balancePercent,
  color,
}) => {
  return (
    <Flex alignItems="center" py="10px">
      <Box
        width="15px"
        height="15px"
        backgroundColor={color}
        rounded="50%"
        mr="10px"
      />
      <Box flex="1" mr="10px">
        <Text>{name}</Text>
      </Box>
      <Text>{Number(balancePercent || 0).toFixed(2)}%</Text>
    </Flex>
  );
};

export default PieChartCompanyListItem;
